import * as React from 'react';

export function SmartPricing() {
  return (
    <section className="gastro-pricing">
      <style>{`
        .gastro-pricing {
          padding: 72px 24px;
          background: #fafaf7;
        }
        .gastro-pricing-inner {
          max-width: 720px;
          margin: 0 auto;
        }
        .gastro-pricing h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 8px;
          line-height: 1.3;
        }
        .gastro-pricing .subtitle {
          font-size: 20px;
          font-weight: 600;
          color: #1EAA25;
          margin: 0 0 28px;
        }
        .gastro-pricing p {
          font-size: 16px;
          color: #444;
          line-height: 1.7;
          margin: 0 0 20px;
        }
        .gastro-pricing .benefit-list {
          list-style: none;
          padding: 0;
          margin: 24px 0 0;
        }
        .gastro-pricing .benefit-list li {
          display: flex;
          align-items: center;
          gap: 12px;
          font-size: 16px;
          color: #333;
          padding: 10px 0;
          border-bottom: 1px solid #eee;
        }
        .gastro-pricing .benefit-list li:last-child {
          border-bottom: none;
        }
        .gastro-pricing .benefit-list li i {
          color: #1EAA25;
          font-size: 16px;
          flex-shrink: 0;
        }
        @media (max-width: 640px) {
          .gastro-pricing h2 {
            font-size: 24px;
          }
        }
      `}</style>
      <div className="gastro-pricing-inner">
        <h2>No competimos por ser los más baratos.</h2>
        <p className="subtitle">Competimos por ser los más predecibles.</p>
        <p>
          La diferencia entre un producto promedio y uno excelente suele ser mínima en costo.
          Pero enorme en percepción.
        </p>
        <p>Cuando la calidad es constante:</p>
        <ul className="benefit-list">
          <li><i className="fa fa-check" /> El plato sale igual todos los días</li>
          <li><i className="fa fa-check" /> El cliente vuelve</li>
          <li><i className="fa fa-check" /> La reputación crece</li>
        </ul>
      </div>
    </section>
  );
}
